module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-1x1_5-a7edf5000ea02c37d3e1ea9faf580024.jpg";